<template>
  <div class="categories">
    <div class="header d-none d-sm-block">
      <FloatingLogo></FloatingLogo>
      <div
        class="header-slider"
        :style="`background-image: url(${headerBackgroundImageUrl})`">
      </div>
    </div>

    <div class="header mobile d-xs-block d-sm-none">
      <FloatingLogo></FloatingLogo>
      <div
        class="header-slider"
        :style="`background-image: url(${mobileHeaderBackgroundImageUrl})`"
      ></div>
    </div>

    <BackButton></BackButton>

    <div class="body">
      <b-container class="categories-list">
        <b-row align-h="center">
          <CategoryItem
            v-for="(item, index) in this.$store.state.staticCategories"
            v-bind:category="item"
            v-bind:index="index"
            v-bind:key="item.id"
            v-on:category-on-click="categoryOnClick"
          >
          </CategoryItem>
        </b-row>
      </b-container>
    </div>

    <div class="bottom-spacer"></div>
    <Footer></Footer>
  </div>
</template>

<script>

  import CategoryItem from "../components/CategoryItem";
  import Footer from "../components/Footer";
  import FloatingLogo from "../components/FloatingLogo";
  import BackButton from "../components/BackButton";
  export default {
    name: "Home",
    components: {
      BackButton,
      FloatingLogo,
      Footer,
      CategoryItem
      // HelloWorld
    },
    data() {
      return {
        selectedCategory: "",
        headerBackgroundImageUrl: "",
        mobileHeaderBackgroundImageUrl: ""
      };
    },
    created () {
      this.routeChanged()
    },
    watch: {
      "$route.params": function() {
        this.routeChanged()
      }
    },
    methods: {
      categoryOnClick: function(category) {
        console.log(category.name);
        this.$store.dispatch({
          type: "action",
          actionType: this.$types.SET_SELECTED_CATEGORY,
          value: category
        })
          .then((result) => {
            // console.log("result: ", result);
            this.doSearch()
          })

      },
      routeChanged: function() {
        // console.log("Route changed: ", this.$route.params);
        this.headerBackgroundImageUrl = "";

        const selectedStateArr = this.$store.state.staticStates.filter(
          stateObj => stateObj.value !== null ? stateObj.value.id == this.$route.params.state : false
        );

        if (selectedStateArr.length < 1) {
          console.log("array.length < 1")
          this.goHome();
          return;
        }

        const selectedState = selectedStateArr[0].value;

        if (this.$route.params.stateName !== selectedState.slug) {
          console.log("param and slug don't match", this.$route.params.stateName, selectedState.slug)
          this.goHome();
          return;
        }

        const imageUrl = `${this.$constants.STATES_HEADER_BASE_URL}${selectedState.slug}${this.$constants.STATES_HEADER_EXT}`
        const mobileImageUrl = `${this.$constants.MOBILE_STATES_HEADER_BASE_URL}${selectedState.slug}${this.$constants.STATES_HEADER_EXT}`

        // console.log(imageUrl);

        this.headerBackgroundImageUrl = imageUrl;
        this.mobileHeaderBackgroundImageUrl = mobileImageUrl;

      },
      doSearch: function() {
        this.$router.push({
          name: "results",
          params: {
            stateName: this.$route.params.stateName,
            state: this.$route.params.state,
            categoryName: this.$store.state.selectedCategory.slug,
            category: this.$store.state.selectedCategory.id
          }
        });
      },
      goHome: function () {
        this.$router.replace({
          name: "home"
        });
      },
      navigateHome: function () {
        this.$router.push({
          name: "home"
        });
      }
    }
  };
</script>
